<ng-sidebar-container>
  <ng-sidebar *ngIf="sideBarShow" [(opened)]="sideBarOpen" position="right" [animate]="sideBarAnimate" [keyClose]="false">
    <div class="sidebar-fix" >
      <div *ngIf="selected!=null">
        <div class="sidebar header-spacing"></div>


        <div class="sidebar header-spacing"></div>
        <div class="sidebar header">
          <div class="row">
            <div class="col-md-12">
              <h1> {{selected.title}}</h1>
            </div>
          </div>
        </div>
        <div class="sidebar footer">
          <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-8">
              <button class="btn btn-default btn-lg" (click)="cancel(selected)">Cancel</button>
              <button class="btn btn-primary btn-lg" (click)="save(selected)">Update</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-sidebar>

  <div ng-sidebar-content>
    <ngx-page-container>

      <h1>My Offers</h1>
      <ngx-search [(value)]="search"></ngx-search>
      <!--<button class="btn btn-primary btn-sm pull-right" (click)="create()">+</button>-->

      <pagination-controls (pageChange)="p = $event"></pagination-controls>

      <table class="table table-hover">
        <thead>
        <tr>
          <th scope="col">BU</th>
          <th scope="col">Customer</th>
          <th scope="col">Project</th>
          <th scope="col">Equipment</th>
          <th scope="col">Offer date</th>
          <th scope="col">Offer title</th>
          <th scope="col">Status</th>
          <th scope="col">Text</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of filter(search, offers) | paginate: { itemsPerPage: 14, currentPage: p }"
            [class.table-active]="item === selected" [class.table-disabled]="isDeactivated(item)"
            (click)="select(item)" >
          <td>{{$any(item.project)?.businessUnit?.name}}</td>
          <td>{{item.business?.name}}</td>
          <td>{{$any(item.project)?.name}}</td>
          <td>{{$any(item.project)?.material?.name}}</td>
          <td>{{item.date | date: 'MMM dd, yyyy'}}</td>
          <td>{{item.title}}</td>
          <td *ngIf="edit !== item._id">{{$any(item.content)?.status != null ? OfferType[$any(item.content)?.status] : ''}}</td>
          <td *ngIf="edit === item._id"><ngx-form-dropdown [(value)]="$any(item.content).status" [options]="offerStatusMap"></ngx-form-dropdown></td>
          <td *ngIf="edit !== item._id">{{$any(item.content)?.text}}</td>
          <td *ngIf="edit === item._id"><ngx-form-area [(value)]="$any(item.content).text"></ngx-form-area></td>
          <td *ngIf="edit !== item._id">
            <button class="btn btn-default btn-sm" (click)="edit = item._id"><i class="ion-edit"></i></button>
          </td>
          <td *ngIf="edit === item._id">
            <button class="btn btn-default btn-sm" (click)="saveOffer(item)"><i class="ion-checkmark"></i></button>
            <button class="btn btn-default btn-sm" (click)="reload()"><i class="ion-close"></i></button>
          </td>

        </tr>
        </tbody>
      </table>
    </ngx-page-container>
  </div>
</ng-sidebar-container>
